import * as types from '../mutation-types'
import { api } from '@/modules/api'
import { path, pathOr } from 'ramda'

const state = {
  sessions: [],
  totalSessionsPages: 0,
  totalSessionsItems: 0
}

const getters = {
  sessionsList: state => state.sessions,
  getSessionById: state => id => state.sessions.find(session => session.id === id),
  totalSessionsPages: state => state.totalSessionsPages,
  totalSessionsItems: state => state.totalSessionsItems,
  sessionsListState: state => state.sessions.reduce((acc, session) => {
    acc[session.id] = {
      sessionType: pathOr(null, ['metadata', 'sessionType'], session),
      location: pathOr(null, ['location', 'id'], session),
      time: session.endTime
    }
    return acc
  }, {})
}

const actions = {
  async changeStatusToPublished ({commit}, { id }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.agenda.setPublishedStatus(), {'sessionId': id, 'status': 'Publish'})
    } catch (err) {
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async createSession ({commit}, session) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.agenda.createSession(), {...session})
      commit(types.CREATE_SUCCESS_MESSAGE, 'Session was created successfully')
    } catch (err) {
      const isTimeIntersectionError = path(['response', 'data', 'ValidationFailures'], err).some((failure) => failure.errorCode === 'agenda-session-0005')
      if (isTimeIntersectionError) {
        commit(types.CREATE_ERROR_MESSAGE, 'Session inersects with another one via start or end date')
      } else {
        commit(types.CREATE_ERROR_MESSAGE, 'Session wasn\'t created')
        throw err
      }
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async editSession ({commit}, session) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.agenda.editSession(), {...session})
      commit(types.CREATE_SUCCESS_MESSAGE, 'Session was created successfully')
    } catch (err) {
      const isTimeIntersectionError = path(['response', 'data', 'ValidationFailures'], err).some((failure) => failure.errorCode === 'agenda-session-0005')
      if (isTimeIntersectionError) {
        commit(types.CREATE_ERROR_MESSAGE, 'Session inersects with another one via start or end date')
      } else {
        commit(types.CREATE_ERROR_MESSAGE, 'Session wasn\'t created')
        throw err
      }
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async removeSession ({commit}, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.agenda.removeSession(id))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Session was removed successfully')
    } catch (err) {
      console.log(err.response)
      commit(types.CREATE_ERROR_MESSAGE, 'Session wasn\'t removed')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async getSessionsList ({commit}, payload = {}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.agenda.getAgendaSessions(payload))
      commit(types.SET_SESSIONS_LIST, response.data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Sessions wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_SESSIONS_LIST] (state, { agendaSessions, totalPages, totalItems }) {
    state.sessions = [...agendaSessions]
    state.totalSessionsPages = totalPages
    state.totalSessionsItems = totalItems
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/agenda-sessions.js